import logging from '@wr/logging';
import {getErrorStatusCode} from '../components/pages/PoliStatusWaiting/helpers';
import config from '../config';
import eventIds from '../event-ids';
import {throwOnResponseError} from '../utils/createResponseError';

const getAdyenInit = async ({
    requestId, sessionId, query: {paymentSessionId}
}) => {
    const logger = logging.createLogger(config.app.name, config.logger.logServerUrl);
    const logProps = {requestId, sessionId, paymentSessionId};

    logger.info('Retrieving Adyen init data', {
        eventId: eventIds['Retrieving Adyen init data'],
        ...logProps
    });

    try {
        const url = new URL(`/api/sessions/${paymentSessionId}/init`, config.adyen.api);

        const initResponse = await fetch(url.toString(), {
            method: 'POST',
            headers: {
                'X-WR-PLATFORM': 'WEB'
            }
        });

        throwOnResponseError(initResponse);

        const initData = await initResponse.json();
        logger.info('Retrieved Adyen init data', {
            eventId: eventIds['Retrieved Adyen init data'],
            ...logProps,
            payload: initData
        });

        return initData;
    } catch (e) {
        const error = new Error(`Error retrieving Adyen init data: ${e.message}`);
        error.status = getErrorStatusCode(e);
        logger.error(error.message, {
            eventId: eventIds['Error retrieving Adyen init data'],
            ...logProps
        });

        throw error;
    }
};

export default getAdyenInit;
